import { clsx } from 'clsx'
import { CircleButton } from 'component/Button/CircleButton'
import { Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { itemPreview } from 'page/catalog/store/ItemPreviewStore'
import css from './Dots.module.scss'

const ARROWS = false

function buildDots(current: number, len: number): number[] {
  const dots: number[] = []
  const last = len - 1
  let left = current - 2
  let right = current + 2
  const left_fix = right - last
  const right_fix = -left
  if (left_fix > 0) left -= left_fix
  if (right_fix > 0) right += right_fix
  left = Math.max(0, left)
  right = Math.min(last, right)
  for (let index = left; index <= right; ++index) {
    dots.push(index)
  }
  return dots
}

type Props = {
  index: number
}

const Dot = observer(({ index }: Props) => {
  const store = itemPreview.it
  const active = index === store.current
  const className = clsx(css.dot, active && css.active)

  const onClick = useLatestCallback(() => {
    store.current = index
  })

  return <div className={className} onClick={onClick} />
})

export const Dots = observer(() => {
  const store = itemPreview.it
  const { current, len } = store
  const left = current > 0
  const right = current < len - 1
  const dots = buildDots(current, len)

  const onLeft = useLatestCallback(() => {
    --store.current
  })

  const onRight = useLatestCallback(() => {
    ++store.current
  })

  return <Space className={css.box} gap={4} center>
    {ARROWS && <CircleButton clear disabled={!left} onClick={onLeft}>
      <Icon size={20} name="keyboard_arrow_left" />
    </CircleButton>}
    {dots.map(index => <Dot key={index} index={index} />)}
    {ARROWS && <CircleButton clear disabled={!right} onClick={onRight}>
      <Icon size={20} name="keyboard_arrow_right" />
    </CircleButton>}
  </Space>
})
